import React, { ReactElement } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, AppContextType } from '@contexts/AppContext';

import EmailLeadCapture from '.';
import { EmailLeadCaptureProps } from './constants';

type EmailLeadCaptureWithQueryClientWrapperProps = EmailLeadCaptureProps & AppContextType;

const EmailLeadCaptureWithQueryClientWrapper = (
  props: EmailLeadCaptureWithQueryClientWrapperProps
): ReactElement => {
  return (
    <AppContextProvider
      env={props.env}
      initialCurrentUser={props.initialCurrentUser}
      isGdprRequired={props.isGdprRequired}
      isWebview={props.isWebview}
    >
      <QueryClientProvider client={new QueryClient()}>
        <EmailLeadCapture {...props} />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default EmailLeadCaptureWithQueryClientWrapper;
